module.exports = __webpack_public_path__ + "media/images/article/2022_06-e50df406c5b5fed4da367269b894abbd.png";